import { FC, useEffect, useState } from "react";
import { useRealtimeDeployments } from "./RealtimeDeployments";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../../lib/src/components/form/Button";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

export const RealtimeDeploymentStatusBar: FC = () => {
  const [dismissed, setDismissed] = useState<boolean>(false)
  const realtimeDeployments = useRealtimeDeployments()

  // Reset the dismissed state when the deployment is done
  useEffect(() => {
    if (dismissed && !realtimeDeployments?.deploymentInProgress) {
      setDismissed(false)
    }
  }, [dismissed, realtimeDeployments?.deploymentInProgress])

  if (!realtimeDeployments) {
    return <></>
  }
  const visible = realtimeDeployments.deploymentInProgress && !dismissed
  return <div className={`${visible ? 'h-14' : 'h-0'} bg-white transition-all flex items-center border-b border-slate-100 px-6 font-medium text-lg space-x-4`}>
    {visible && <>
      <FontAwesomeIcon icon={faCircleNotch} spin className={"text-slate-400"} />
      <div className={"text-slate-600 flex-1"}>Deploying changes&hellip;</div>
      <Button type={'secondary'} size={'xs'} text={'Dismiss'} onClick={() => setDismissed(true)} />
    </>}
  </div>
}
